jQuery(document).ready(function($) {
  $('#sustainable-slider').slick({
    appendArrows: '#sustainable-slider-arrows',
    prevArrow: '<div class="sustainable-arrow" id="sustainable-prev"><i class="far fa-chevron-left"></i></div>',
    nextArrow: '<div class="sustainable-arrow" id="sustainable-next"><i class="far fa-chevron-right"></i></div>'
  })

  $('#sustainable-slider').on("beforeChange", function(event, slick, current, next) {
    $('#sustainable-slider-counter').text(next + 1);
  })
})
